import { QdeService } from 'src/app/services/qde.service';
import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, Validators } from "@angular/forms";
import { GENERIC_ERRORS, GENERIC_ERROR, verbiageList, VALIDATE_QDE_OTP_URL_DECRYPT, VALIDATE_OTP_URL_DECRYPT } from 'src/app/config/app-settings.config';
import { OtpStatusValues } from 'src/app/utilities/utilities.file';
import { IwService } from 'src/app/services/iw.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { map, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EncrDecrService } from 'src/app/services/encr-decr-service.service';
import { ThemeService } from 'src/app/services/theme.service';
declare var _satellite: any;
@Component({
  selector: "app-otp-model-box",
  templateUrl: "./otp-model-box.component.html",
  styleUrls: ["./otp-model-box.component.scss"]
})
export class OtpModelBoxComponent implements OnInit {
  fcnOtp: FormControl;
  eapplyFormLabel: any;
  invalidOtp = false;
  errorMessage: any;
  genericErrors: any;
  successMessage: any;
  dcrData: any;
  counter = 0;
  existingJCounter = 0;
  counterValidate = 0;
  existingJCounterValidate = 0;
  verbiageList = verbiageList;
  diaplayOtpInput: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OtpModelBoxComponent>,
    private qdeService: QdeService,
    private iw: IwService,
    private sharedService: SharedServiceService,
    private encryptDecService: EncrDecrService,
    private router: Router,
    private themeService: ThemeService
  ) { 
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    // let element : any =  document.getElementsByClassName('cdk-overlay-backdrop')[0];
    // this.partnerCode && this.containerType?element.style.opacity = '0':true;
    if(this.partnerCode&&this.containerType){
      document.getElementById('sbicard')?document.getElementById('sbicard').style.background = 'radial-gradient(#d4cccc, transparent)':true;
      let element : any =  document.getElementsByClassName('iw_viewport-wrapper')[0];
      element.style.display = 'none';
    }
    this.fcnOtp = new FormControl("", [Validators.required]);
    this.eapplyFormLabel = this.iw.geteapplyFormLabelDcr().dcrContent.root;
    this.genericErrors = GENERIC_ERRORS;
    this.dcrData = JSON.parse(localStorage.getItem('convertedJson')).root;
    this.existingJCounter = this.data.existingJourneyCounter ? this.data.existingJourneyCounter : null;
    this.counter = this.data.newJourneyCounter ? this.data.newJourneyCounter : null;
    this.existingJCounterValidate = this.qdeService.existingJCounterValidate ? this.qdeService.existingJCounterValidate : 0;
    this.counterValidate = this.qdeService.counterValidate ? this.qdeService.counterValidate : 0;
    this.validateOtp();
  }

  close() {
    if(this.existingJCounter){
      this.qdeService.existingJCounterValidate = this.existingJCounterValidate;
      this.existingJCounter = this.existingJCounterValidate>=5 || this.counterValidate>=5 ? 5 : this.existingJCounter;
      if(this.partnerCode&&this.containerType){
        document.getElementById('sbicard')?document.getElementById('sbicard').style.background = 'none':true;
        let element : any =  document.getElementsByClassName('iw_viewport-wrapper')[0];
        element.style.display = 'block';
      }
    this.dialogRef.close({ counter: this.existingJCounter, otpValidated: OtpStatusValues.OTP_NOT_VALIDATED });
    }else {
      this.qdeService.counterValidate = this.counterValidate;
      this.counter = this.existingJCounterValidate>=5 || this.counterValidate>=5 ? 5 : this.counter;
      if(this.partnerCode&&this.containerType){
        document.getElementById('sbicard')?document.getElementById('sbicard').style.background = 'none':true;
        let element : any =  document.getElementsByClassName('iw_viewport-wrapper')[0];
        element.style.display = 'block';
      }
      this.dialogRef.close({ counter: this.counter, otpValidated: OtpStatusValues.OTP_NOT_VALIDATED });
    }
  }

  validateOtp() {
      this.fcnOtp.valueChanges.pipe(
        map((value:any)=>value),
        filter(res=> res && res.length===6),
        debounceTime(1000),
        distinctUntilChanged(),
        ).subscribe(text=>{
      this.diaplayOtpInput = this.qdeService.qdeOtpCount
      let requestBody: any;
      let fromQdeFlag: any
      if (this.data.existingJourneyCounter) {
        requestBody = {
          cardNumber: this.data.creditCardNo ? this.data.creditCardNo : '000' + this.data.mobileNumber + '999999',
          otp: this.fcnOtp.value || null,
          reasonCode: '110',
          mobileNumber: this.data.mobileNumber,
          dsignString: this.sharedService.uuidString
        }
        fromQdeFlag = false;
      } else {
        requestBody = {
          cardNumber: this.data.creditCardNo ? this.data.creditCardNo : '000' + this.data.mobileNumber + '999999',
          otp: this.fcnOtp.value || null,
          reasonCode: '101',
          mobileNumber: this.data.mobileNumber,
          dsignString: this.sharedService.uuidString
        }
        fromQdeFlag = true;
      }
      this.qdeService.validateOtp(requestBody, fromQdeFlag).subscribe((response: any) => {
        if(response && fromQdeFlag){
          response = VALIDATE_QDE_OTP_URL_DECRYPT ? this.encryptDecService.get(response) : response;
          console.log("response validate otp = " ,response)
        }else if(response && !fromQdeFlag){
          response = VALIDATE_OTP_URL_DECRYPT ? this.encryptDecService.get(response) : response;
        }
        if (response.OtpValidationRsType.status.toLowerCase() === 'success' && response.OtpValidationRsType.statusCode === "000" && response.OtpValidationRsType.dsignString === this.sharedService.uuidString) {
          if (response.OtpValidationRsType.signedValue) {
            this.qdeService.signedValueResponse = response.OtpValidationRsType.signedValue;
            if (this.data.newJourneyCounter) {
              if(window['_satellite']){
                _satellite.track("mobile_number_verify");
              }
            }
          }
          if (this.data.existingJourneyCounter) {
            const requestBodyForExisting = {
              creditCardNumber: this.data.creditCardNo,
              mobileNumber: this.data.mobileNumber,
              interestedCardCategory: this.dcrData.card_information.card_category,
              interestedCardType: this.dcrData.card_information.card_type
            }
            this.qdeService.existingUserSubmit(requestBodyForExisting).subscribe((result: any) => {
              if (result.SaveExistingCustDetailsRsType && result.SaveExistingCustDetailsRsType.status.toLowerCase() === 'success') {
                this.successMessage = this.genericErrors.success;
                this.qdeService.successMessageOTP = this.successMessage;
                this.errorMessage = false;
                this.qdeService.errorMessageOTP = this.errorMessage;
                this.sharedService.existingMessage = `${this.genericErrors.existingCustomerSaveSuccess1}${this.sharedService.sbic_card_name}${this.genericErrors.existingCustomerSaveSuccess2}`;
                this.router.navigate(['/', 'success']);
                this.dialogRef.close({ status: result.SaveExistingCustDetailsRsType, counter: this.existingJCounter, otpValidated: OtpStatusValues.OTP_VALIDATED });
              } else {
                this.errorMessage = GENERIC_ERROR;
                this.qdeService.errorMessageOTP = this.errorMessage;
                this.successMessage = false;
                this.qdeService.successMessageOTP = this.successMessage;
                this.dialogRef.close({ status: result.SaveExistingCustDetailsRsType, counter: this.existingJCounter, otpValidated: OtpStatusValues.OTP_VALIDATED });
              }
            }, error => {
              this.errorMessage = GENERIC_ERROR;
              this.qdeService.errorMessageOTP = this.errorMessage;
              this.dialogRef.close({ error: error, counter: this.existingJCounter, otpValidated: OtpStatusValues.OTP_VALIDATED });
            })
          } else {
            this.dialogRef.close({ counter: this.counter, otpValidated: OtpStatusValues.OTP_VALIDATED });
          }
        } else {
          this.invalidOtp = true;
          this.counterValidate = this.counterValidate + 1;
          this.existingJCounterValidate = this.existingJCounterValidate + 1;
          this.fcnOtp.setValue('');
        }
      }, error => {
      })
    });
  }

  resendCode() {
    if (this.qdeService.qdeOtpCount || (this.qdeService.existingOtpCounter >= 5) || (this.qdeService.qdeOtpCounter >= 5)) {
      return
    } else {
      let reasonCode: any;
      if (this.data.existingJCounter) {
        reasonCode = '110';
      } else {
        reasonCode = '101';
      }
      if ((this.data.existingJourneyCounter && this.existingJCounter <= 4) || (this.data.newJourneyCounter && this.counter <= 4)) {
        this.invalidOtp = false;
        this.qdeService.generateOtp(this.data.creditCardNo, this.data.mobileNumber, 'true', reasonCode)
          .subscribe(
            (result: any) => {
              if ((result.OTPGenerationRsType.statusDesc).toLowerCase() === 'success' && result.OTPGenerationRsType.statusCode == "000") {
                if (this.data.existingJourneyCounter) {
                  this.existingJCounter += 1;
                  this.qdeService.existingOtpCounter = this.existingJCounter
                } if (this.data.newJourneyCounter) {
                  this.counter = this.counter + 1;
                  this.qdeService.qdeOtpCounter = this.counter;
                }
                this.errorMessage = '';
              } else if ((result.OTPGenerationRsType.statusDesc).toLowerCase() === 'error occured') {
                this.errorMessage = GENERIC_ERROR;
              }
            }, error => {
              this.errorMessage = GENERIC_ERROR;
            }
          )
      } else {
        this.qdeService.qdeOtpCount = true;
        this.diaplayOtpInput = this.qdeService.qdeOtpCount;
      }
    }
  }

  numberOnly(event) {
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }
}
